// This file is part of the Smart Building Message Gateway.
//
//   |     __| _ _|   __|   _ \   \  |
//   |     _|    |   (     (   | |\/ |
//  ____| ___| ___| \___| \___/ _|  _|
//
// Copyright © 2025 LEICOM AG. All Rights Reserved.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
// BUT NOT LIMITED  TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// @author      Christian Stauffer <christian.stauffer@leicom.ch>, et al.

import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { PiPhoneIncomingFill } from "react-icons/pi";
import { MdOutgoingMail, MdGroupAdd, MdCancel, MdDone, MdOutlineAutorenew } from "react-icons/md";
import { RiSettings5Line } from "react-icons/ri";
import { CgPassword } from "react-icons/cg";
import { FaRegTrashCan } from "react-icons/fa6";
import { LuUndo2 } from "react-icons/lu";
import { IoMdAdd } from "react-icons/io";
import { FaUserGroup } from "react-icons/fa6";


import './Configuration.css'

function Configuration() {

  // const location = useLocation();
  // const { token } = location.state || {};
  // const apiKey = window.env.API_KEY;
  // const api = window.env.API_URL;
  const [tokenConfigOpen, setTokenConfigOpen] = useState(false);
  const [gatewayConfigOpen, setGatewayConfigOpen] = useState(false);
  const [sourceConfigOpen, setSourceConfigOpen] = useState(false);
  const [customerConfigOpen, setCustomerConfigOpen] = useState(false);

  const [selected, setSelected] = useState(null);

  const select = async (e, name) => {

    setSourceConfigOpen(false);
    setGatewayConfigOpen(false);
    setTokenConfigOpen(false);
    setCustomerConfigOpen(false);

    switch(name){
      case "source":
        setSourceConfigOpen(true);
        break;
      case "gateway":
        setGatewayConfigOpen(true);
        break;
      case "token":
        setTokenConfigOpen(true);
        break;
      case "customer":
        setCustomerConfigOpen(true);
        break;
      default:
    }
    setSelected(name);
  }

  useEffect((e) => {
    select(e, "source");
  }, []);

  return (
      <div className="page">
          <div className="header">
              <RiSettings5Line className="menu-icon" />
              <h2>Configuration</h2>
          </div>
          <nav className="submenu">
            <ul className='submenu'>
              <li className='submenu'>
                <button className={`submenu ${selected === "source" ? "selected" : ""}`} onClick={(e) => select(e, "source")}><PiPhoneIncomingFill className="submenu-icon"/> Message Sources</button>
              </li>
              <li className='submenu'>
                <button className={`submenu ${selected === "gateway" ? "selected" : ""}`} onClick={(e) => select(e, "gateway")}><MdOutgoingMail className="submenu-icon"/> Message Gateways</button>
              </li>
              <li className='submenu'>
                <button className={`submenu ${selected === "token" ? "selected" : ""}`} onClick={(e) => select(e, "token")}><CgPassword className="submenu-icon"/> API Token</button>
              </li>
              <li className='submenu'>
                <button className={`submenu ${selected === "customer" ? "selected" : ""}`} onClick={(e) => select(e, "customer")}><FaUserGroup className="submenu-icon"/> Customer</button>
              </li>
            </ul>
          </nav>
          {tokenConfigOpen && <TokenConfig />}
          {gatewayConfigOpen && <GatewayConfig />}
          {sourceConfigOpen && <h1>Sources</h1>}
          {customerConfigOpen && <CustomerConfig />}
      </div>
    );
}

//
// Tokens
//

function TokenConfig() {

  const location = useLocation();
  const { token } = location.state || {};
  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const [userTokens, setTokens] = useState([]);
  const [formOpen, setFormOpen] = useState(false);

  const fetchTokens = async () => {
    try {   

      const response = await fetch(`${api}/tokens`, {
        method: "GET",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });
      if (response.ok) {
        const tokens = await response.json()
        
        if (tokens == null){
          tokens = JSON.stringify([])
        }
        console.log("Tokens", tokens)
        setTokens(tokens)
      } else {
        console.log("fetch token failed")
        // setError("Cannot fetch Tokens.");
      }

    } catch (err) {
      console.log("fetch token excepted", err)
      // setTokens(JSON.stringify([]))
    }
  }

  useEffect(() => {
    fetchTokens();
  }, [api, token]);


  const removeToken = async (userToken) => {
    console.log("remove token", userToken.id)

    try {   
      const response = await fetch(`${api}/tokens?id=${userToken.id}`, {
        method: "DELETE",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });
      if (response.ok) {
        
        console.log("token successful removed")
      } else {
        console.log("token NOT removed")
        // setError("Cannot fetch Tokens.");
      }

    } catch (err) {
      alert("network problems Token Config", err)
      return (<Navigate to="/login" />);
    }

    fetchTokens()
  };

  const revokeToken = async (userToken) => {
    console.log("revoke token", userToken.id)
    try {   
      const response = await fetch(`${api}/token-revoke?id=${userToken.id}`, {
        method: "POST",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });
      if (response.ok) {
        
        console.log("token successful revoked")
      } else {
        console.log("token NOT revoked")
        // setError("Cannot fetch Tokens.");
      }

    } catch (err) {
      alert("network problems Token Config", err)
      return (<Navigate to="/login" />);
    }

    fetchTokens()
  };

  const addToken = async (e) => {
    console.log("add token")
    openForm()
  };

  const closeForm = (e) => {
    console.log("close form")
    setFormOpen(false)
    fetchTokens()
  };

  const openForm = (e) => {
    setFormOpen(true)
  }

  return (
      <div>
        {formOpen && <TokenForm close={closeForm} />}
        <h2>API Token</h2>
        <button onClick={addToken}><IoMdAdd /> Add Token</button>
        
        <div className="settings">
        <table>
          <thead><tr><td>ID</td><td>Customer ID</td><td>Hash</td><td>Revoked</td><td>Expires</td><td>Description</td><td></td></tr></thead>
          <tbody>
            {userTokens.map((token, index) => (
              <tr><td>{token.id}</td><td>{token.customerID}</td><td style={{ whiteSpace: "normal", wordWrap: "break-word" }}>{token.value.slice(0,8)}...</td><td>{token.revoked ? "Yes" : "No"}</td><td>{token.expires}</td><td>{token.description}</td><td><button onClick={() => revokeToken(token)}><LuUndo2 /></button><button onClick={() => removeToken(token)}><FaRegTrashCan /></button></td></tr>  
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function TokenForm({close}){

  const location = useLocation();
  const { token } = location.state || {};
  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const [loading, setLoading] = useState(false);

  const [tokenFormData, setTokenFormData] = useState({
    id:"",
    customerID:0,
    value:"",
    hash:"",
    revoked:false,
    expires:"",
    description:""
  });

  const genToken = (e) => {
    const hex = [...crypto.getRandomValues(new Uint8Array(16))].map(b => b.toString(32).padStart(2, '0')).join('');
    tokenFormData.value = hex;
    formChange(e)
  }

  const addToken = async (e) => {

    e.preventDefault();

    setLoading(true);

    console.log("add token", tokenFormData.id, tokenFormData.value)

    try {
      var body = {
        "value": tokenFormData.value,
        "revoked": tokenFormData.revoked,
        "expires": tokenFormData.expires,
        "description": tokenFormData.description
      }

      if (tokenFormData.customerID > 0){
        body["customerID"] = tokenFormData.customerID
      }

      const response = await fetch(`${api}/tokens`, {
        method: "POST",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
        body:JSON.stringify(
          body
        ),
      });
      if (response.ok) {
        const addedToken = await response.json()
        
        console.log("Added Token", addedToken)
        setTokenFormData(addedToken)
      } else {
        console.log("adding token failed")
      }
      close();

    } catch (err) {
      console.log("adding token excepted", err)
    }finally{
      setLoading(false);
    }
  };

  const formChange = (e) => {
    const { name, type, checked, value } = e.target;
  
    let newValue;
  
    if (type === 'checkbox') {
      newValue = checked;
  
    } else if (type === 'number') {
      newValue = Number(value);
  
    } else if (type === 'date') {
      const localDate = new Date(value);
      newValue = new Date(Date.UTC(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate()
      )).toISOString();
  
    } else {
      newValue = value;
    }
  
    setTokenFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };


  return (
    <div className="overlay">
      <div className="form-container">
        <h3>Add Token</h3>
        <form onSubmit={addToken}>
          <input
            type="number"
            name="customerID"
            placeholder="Customer ID"
            value={tokenFormData.customerID}
            onChange={formChange}
          />
          <input
            type="text"
            name="description"
            placeholder="Description"
            value={tokenFormData.description}
            onChange={formChange}
            required
          />
          <input
            type="date"
            name="expires"
            placeholder="Expires at"
            value={tokenFormData.expires.slice(0, 10)}
            onChange={formChange}
          />
          <button type="button" onClick={genToken}><MdOutlineAutorenew /></button>
          <input
            type="text"
            name="value"
            placeholder="Token Value"
            value={tokenFormData.value}
            required
          />
          <div className="form-buttons">
            <button type="submit" disabled={loading}>{loading ? <div className="spinner"></div> : <><MdDone /> Apply</>}</button>
            <button type="button" onClick={close}><MdCancel /> Cancel</button>
          </div>
        </form>
      </div>
    </div>
  )
}

//
// Gateways
//

function GatewayConfig() {

  const location = useLocation();
  const { token } = location.state || {};
  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const [gateways, setGateways] = useState([]);
  const [formOpen, setFormOpen] = useState(false);

  const fetchGateways = async () => {
    try {   

      const response = await fetch(`${api}/gateways`, {
        method: "GET",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });
      if (response.ok) {
        const gateways = await response.json()
        
        if (gateways == null){
          gateways = JSON.stringify([])
        }
        console.log("Gateways", gateways)
        setGateways(gateways)
      } else {
        console.log("fetch gateways failed")
        // setError("Cannot fetch Gateways.");
      }

    } catch (err) {
      console.log("fetch gateways excepted", err)
    }
  }

  useEffect(() => {
    fetchGateways();
  }, [api, token]);


  const removeGateway = async (gateway) => {
    console.log("remove gateway", gateway.id)

    try {   
      const response = await fetch(`${api}/gateways?id=${gateway.id}`, {
        method: "DELETE",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });
      if (response.ok) {
        
        console.log("gateway successful removed")
      } else {
        console.log("gateway NOT removed")
        // setError("Cannot fetch Gateways.");
      }

    } catch (err) {
      alert("network problems Gateway Config", err)
      return (<Navigate to="/login" />);
    }

    fetchGateways()
  };

  const addGateway = async (e) => {
    console.log("add token")
    openForm()
  };

  const closeForm = (e) => {
    console.log("close form")
    setFormOpen(false)
    fetchGateways()
  };

  const openForm = (e) => {
    setFormOpen(true)
  }

  return (
      <div>
        {formOpen && <GatewayForm close={closeForm} />}
        <h2>Gateways</h2>
        <button onClick={addGateway}><IoMdAdd /> Add Gateway</button>
        
        <div className="settings">
        <table>
          <thead><tr><td>ID</td><td>Customer ID</td><td>Host</td><td>Port</td><td>Username</td><td>Password</td><td>Type</td><td>Description</td><td></td></tr></thead>
          <tbody>
            {gateways.map((gateway, index) => (
              <tr><td>{gateway.id}</td><td>{gateway.customerID}</td><td>{gateway.host}</td><td>{gateway.port}</td><td>{gateway.username}</td><td>{gateway.password}</td><td>{gateway.typ}</td><td>{gateway.description}</td><td><button onClick={() => removeGateway(gateway)}><FaRegTrashCan /></button></td></tr>  
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function GatewayForm({close}){

  const location = useLocation();
  const { token } = location.state || {};
  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const [loading, setLoading] = useState(false);

  const [gatewayFormData, setGatewayFormData] = useState({
    id:"",
    customerID:0,
    host:"",
    port:0,
    username:"",
    password:"",
    typ:"coniu",
    description:""
  });

  const addGateway = async (e) => {

    e.preventDefault();

    setLoading(true);

    console.log("add gateway", gatewayFormData.id)

    try {
      var body = {
        "host": gatewayFormData.host,
        "port": gatewayFormData.port,
        "typ": gatewayFormData.typ,
      }

      if (gatewayFormData.customerID > 0){
        body["customerID"] = gatewayFormData.customerID
      }
      if (gatewayFormData.description != ""){
        body["description"] = gatewayFormData.description
      }
      if (gatewayFormData.username != ""){
        body["username"] = gatewayFormData.username
      }
      if (gatewayFormData.password != ""){
        body["password"] = gatewayFormData.password
      }

      const response = await fetch(`${api}/gateways`, {
        method: "POST",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
        body:JSON.stringify(
          body
        ),
      });
      if (response.ok) {
        const addedGateway = await response.json()
        
        console.log("Added Gateway", addedGateway)
        setGatewayFormData(addedGateway)
      } else {
        console.log("adding gateway failed")
      }
      close();

    } catch (err) {
      console.log("adding gateway excepted", err)
    }finally{
      setLoading(false);
    }
  };

  const formChange = (e) => {
    const { name, type, checked, value } = e.target;
  
    let newValue;
  
    if (type === 'checkbox') {
      newValue = checked;
  
    } else if (type === 'number') {
      newValue = Number(value);
  
    } else if (type === 'date') {
      const localDate = new Date(value);
      newValue = new Date(Date.UTC(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate()
      )).toISOString();
  
    } else {
      newValue = value;
    }
  
    setGatewayFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };


  return (
    <div className="overlay">
      <div className="form-container">
        <h3>Add Gateway</h3>
        <form onSubmit={addGateway}>
          <label>Customer ID</label>
          <input
            type="number"
            name="customerID"
            placeholder="Customer ID"
            value={gatewayFormData.customerID}
            onChange={formChange}
          />
          <label>Description</label>
          <input
            type="text"
            name="description"
            placeholder="Description"
            value={gatewayFormData.description}
            onChange={formChange}
          />
          <label>Host</label>
          <input
            type="text"
            name="host"
            placeholder="Host"
            value={gatewayFormData.host}
            onChange={formChange}
            required
          />
          <label>Port</label>
          <input
            type="number"
            name="port"
            placeholder="Port"
            value={gatewayFormData.port}
            onChange={formChange}
            required
          />
          <label>Username</label>
          <input
            type="text"
            name="username"
            placeholder="Username"
            value={gatewayFormData.username}
            onChange={formChange}
          />
          <label>Password</label>
          <input
            type="text"
            name="password"
            placeholder="Password"
            value={gatewayFormData.password}
            onChange={formChange}
          />
          <label>Type</label>
          <select
            name="typ"
            value={gatewayFormData.typ}
            onChange={formChange}
            required
          >
            <option value="coniu">Coniu GO SMS Gateway</option>
            <option value="smsd">SMSd Service</option>
            <option value="teltonika">Teltonika API</option>
            <option value="huawei">Huawei API</option>
            <option value="whatsapp">Whatsapp</option>
            <option value="signal">Signal</option>
          </select>

          <div className="form-buttons">
            <button type="submit" disabled={loading}>{loading ? <div className="spinner"></div> : <><MdDone /> Apply</>}</button>
            <button type="button" onClick={close}><MdCancel /> Cancel</button>
          </div>
        </form>
      </div>
    </div>
  )
}

//
// Customers
//

function CustomerConfig() {

  const location = useLocation();
  const { token } = location.state || {};
  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const [customers, setCustomers] = useState([]);
  const [formOpen, setFormOpen] = useState(false);

  const fetchCustomers = async () => {
    try {   

      const response = await fetch(`${api}/customers`, {
        method: "GET",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });
      if (response.ok) {
        const customers = await response.json()
        
        if (customers == null){
          customers = JSON.stringify([])
        }
        console.log("Customers", customers)
        setCustomers(customers)
      } else {
        console.log("fetch customers failed")
        // setError("Cannot fetch Customers.");
      }

    } catch (err) {
      console.log("fetch customers excepted", err)
    }
  }

  useEffect(() => {
    fetchCustomers();
  }, [api, token]);


  const removeCustomers = async (customer) => {
    console.log("remove customer", customer.id)

    try {   
      const response = await fetch(`${api}/customers?id=${customer.id}`, {
        method: "DELETE",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });
      if (response.ok) {
        
        console.log("customer successful removed")
      } else {
        console.log("customer NOT removed")
        // setError("Cannot fetch Customers.");
      }

    } catch (err) {
      alert("network problems Customer Config", err)
      return (<Navigate to="/login" />);
    }

    fetchCustomers()
  };

  const addCustomer = async (e) => {
    console.log("add token")
    openForm()
  };

  const closeForm = (e) => {
    console.log("close form")
    setFormOpen(false)
    fetchCustomers()
  };

  const openForm = (e) => {
    setFormOpen(true)
  }

  return (
      <div>
        {formOpen && <CustomerForm close={closeForm} />}
        <h2>Customers</h2>
        <button onClick={addCustomer}><MdGroupAdd /> Add Customer</button>
        
        <div className="settings">
        <table>
          <thead><tr><td>ID</td><td>Name</td><td>Address</td><td>City</td><td>Country</td><td>Note</td><td></td></tr></thead>
          <tbody>
            {customers.map((customer, index) => (
              <tr><td>{customer.id}</td><td>{customer.name}</td><td>{customer.address}</td><td>{customer.city}</td><td>{customer.country}</td><td>{customer.note}</td><td><button onClick={() => removeCustomers(customer)}><FaRegTrashCan /></button></td></tr>  
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function CustomerForm({close}){

  const location = useLocation();
  const { token } = location.state || {};
  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const [loading, setLoading] = useState(false);

  const [customerFormData, setCustomerFormData] = useState({
    id:"",
    name:"",
    address:"",
    city:"",
    country:"",
    note:""
  });

  const addCustomer = async (e) => {

    e.preventDefault();

    setLoading(true);

    console.log("add customer", customerFormData.id)

    try {
      var body = {
        "name": customerFormData.name,
        "address": customerFormData.address,
        "city":  customerFormData.city,
        "country":  customerFormData.country,
        "note":  customerFormData.note,
      }

      const response = await fetch(`${api}/customers`, {
        method: "POST",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
        body:JSON.stringify(
          body
        ),
      });
      if (response.ok) {
        const addedCustomer = await response.json()
        
        console.log("Added Customer", addedCustomer)
        setCustomerFormData(addedCustomer)
      } else {
        console.log("adding customer failed")
      }
      close();

    } catch (err) {
      console.log("adding customer excepted", err)
    }finally{
      setLoading(false);
    }
  };

  const formChange = (e) => {
    const { name, type, checked, value } = e.target;
  
    let newValue;
  
    if (type === 'checkbox') {
      newValue = checked;
  
    } else if (type === 'number') {
      newValue = Number(value);
  
    } else if (type === 'date') {
      const localDate = new Date(value);
      newValue = new Date(Date.UTC(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate()
      )).toISOString();
  
    } else {
      newValue = value;
    }
  
    setCustomerFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };


  return (
    <div className="overlay">
      <div className="form-container">
        <h3>Add Customer</h3>
        <form onSubmit={addCustomer}>
          <label>Name</label>
          <input
            type="text"
            name="name"
            placeholder="Customer Name"
            value={customerFormData.name}
            onChange={formChange}
            required
          />
          <label>Address</label>
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={customerFormData.address}
            onChange={formChange}
            required
          />
          <label>City</label>
          <input
            type="text"
            name="city"
            placeholder="City"
            value={customerFormData.city}
            onChange={formChange}
            required
          />
          <label>Country</label>
          <input
            type="text"
            name="country"
            placeholder="Country"
            value={customerFormData.country}
            onChange={formChange}
            required
          />
          <label>Note</label>
          <input
            type="text"
            name="note"
            placeholder="Note"
            value={customerFormData.note}
            onChange={formChange}
          />

          <div className="form-buttons">
            <button type="submit" disabled={loading}>{loading ? <div className="spinner"></div> : <><MdDone /> Apply</>}</button>
            <button type="button" onClick={close}><MdCancel /> Cancel</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Configuration;
